import React from 'react';
import { Sparkles, Infinity as InfinityIcon } from 'lucide-react';
export function LifetimeAccessBonus() {
  return <div className="mt-8" data-id="element-312">
      <div className="bg-[#FFFBF2] rounded-3xl p-6 border-2 border-[#D4AF37]/40 shadow-lg relative overflow-hidden" data-id="element-313">
        <div className="relative z-10 flex flex-col md:flex-row items-center gap-6" data-id="element-314">
          <div className="shrink-0 w-24 md:w-32" data-id="element-315">
            <img src="https://cdn.magicpatterns.com/uploads/q95pnAgWMR4B9QZwBL1Zcx/Diseno_sin_titulo.png" alt="Acceso Vitalicio" className="w-full h-auto drop-shadow-md" data-id="element-316" />
          </div>

          <div className="flex-1 text-center md:text-left" data-id="element-317">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-violet-600 text-white text-[9px] font-black uppercase tracking-widest mb-3" data-id="element-318">
              <Sparkles size={10} data-id="element-319" />
              <span data-id="element-320">BONO EXTRA</span>
            </div>

            <h3 className="text-xl md:text-2xl font-black text-violet-950 uppercase italic mb-2 font-[Poppins]" data-id="element-321">
              Acceso <span className="text-violet-600" data-id="element-322">Vitalicio</span>
            </h3>

            <p className="text-violet-900/80 text-sm md:text-base leading-snug mb-3 font-medium" data-id="element-323">
              Un solo pago, acceso de por vida a todo el material y futuras
              actualizaciones. Sin mensualidades.
            </p>

            <div className="flex items-center justify-center md:justify-start gap-2 text-violet-600 font-black uppercase tracking-widest text-[10px]" data-id="element-324">
              <InfinityIcon size={14} data-id="element-325" />
              <span data-id="element-326">INCLUIDO GRATIS</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}